import {createAction} from 'redux-actions';
import {Asset, Depot, DoorStatus, Thing} from '../api/types';

export interface DepotsFetchedPayload {
    depots: Depot[];
}

export interface DepotAssetsFetchedPayload {
    depotId: string;
    assets: Asset[];
}

export interface DoorStatusFetchedPayload {
    depotId: string;
    doorStatus: DoorStatus;
}

export interface DoorStatusFetchStartedPayload {
    depotId: string;
}

/**
 * The fetch ended without data. Needed as its own event so the reload
 * indicator stops turning on a failed request — a spinner with no terminal
 * event spins forever, which is the same "looks like it's still working"
 * problem the indicator was added to solve.
 */
export interface DoorStatusFetchFailedPayload {
    depotId: string;
}

export interface DoorOpenedPayload {
    depotId: string;
    doorNumber: number;
}

export interface DepotUpdatedPayload {
    id: string;
    enabled: boolean;
}

export interface ThingsFetchedPayload {
    things: Thing[];
}

/* eslint-disable max-len */
export const depotsFetched = createAction<DepotsFetchedPayload>('DEPOTS_FETCHED');
export const depotAssetsFetched = createAction<DepotAssetsFetchedPayload>('DEPOT_ASSETS_FETCHED');
export const doorStatusFetched = createAction<DoorStatusFetchedPayload>('DOOR_STATUS_FETCHED');
export const doorStatusFetchStarted = createAction<DoorStatusFetchStartedPayload>('DOOR_STATUS_FETCH_STARTED');
export const doorStatusFetchFailed = createAction<DoorStatusFetchFailedPayload>('DOOR_STATUS_FETCH_FAILED');
export const doorOpened = createAction<DoorOpenedPayload>('DOOR_OPENED');
export const depotUpdated = createAction<DepotUpdatedPayload>('DEPOT_UPDATED');
export const thingsFetched = createAction<ThingsFetchedPayload>('THINGS_FETCHED');
